import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,       // 5 minutes
      gcTime: 60 * 60 * 1000,          // 1 hour (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Common query key factories */
export const queryKeys = {
  // Reference data (rarely changes)
  checks: {
    all: ['checks'] as const,
    byLocation: (locationId: number) => ['checks', 'by-location', locationId] as const,
  },
  items: {
    all: ['items'] as const,
    songs: ['items', 'songs'] as const,
  },
  locations: {
    areas: ['locations', 'areas'] as const,
    byArea: (areaId: number) => ['locations', 'by-area', areaId] as const,
  },
  entrances: {
    all: ['entrances'] as const,
  },
  tricks: {
    all: ['tricks'] as const,
    byId: (id: number) => ['tricks', id] as const,
    difficulties: ['tricks', 'difficulties'] as const,
  },
  sessions: {
    byCode: (code: string) => ['sessions', code] as const,
    mine: ['sessions', 'mine'] as const,
  },
  templates: {
    all: ['templates'] as const,
  },
  referenceData: {
    eras: ['reference-data', 'eras'] as const,
    pathGoals: ['reference-data', 'path-goals'] as const,
  },
} as const;
